module.exports = __webpack_public_path__ + "public/images/prizes/prize-3.fb5345ed83bc19bcfa172bd94112c63f.jpg";